const initialState = () => {
    return {
        selectedProducts: [],
        slideToImage: null
    }
};

const state = initialState();

const mutations = {
    SET_SELECTED_PRODUCTS(state, payload) {
        state.selectedProducts = state.selectedProducts.filter(o => o.product_id !== payload.product_id);
        state.selectedProducts.push(payload);
    },
    UPDATE_ACTIVE_GALLERY_IMAGE(state, payload) {
        state.slideToImage = payload;
    }
};

const actions = {
    updateSelectedProduct({state, commit}, payload) {
        commit('SET_SELECTED_PRODUCTS', payload);
    },
    slideToGalleryImage({state, commit}, payload) {
        commit('UPDATE_ACTIVE_GALLERY_IMAGE', payload);
    }
};

const getters = {
    availableProducts: (state, getters, rootState) => {
        return Object.prototype.hasOwnProperty.call(rootState.CatalogProduct.productData, 'child_products') ? rootState.CatalogProduct.productData.child_products : [];
    },
    slideToGalleryImage: state => {
        return state.slideToImage;
    },
    fromPrices: (state, getters) => {
        let prices = {
            totalPriceInclTax: 0,
            totalPriceExclTax: 0
        };
        if (getters.availableProducts.length > 0) {
            const lowestPrice = getters.availableProducts.reduce((a, b) => a.final_price_incl_tax < b.final_price_incl_tax ? a : b);
            prices.totalPriceInclTax = lowestPrice.final_price_incl_tax;
            prices.totalPriceExclTax = lowestPrice.final_price_excl_tax;
        }
        return prices;
    },
    totalPrices: state => {
        let prices = {
            priceInclTax: 0,
            priceExclTax: 0,
            totalPriceInclTax: 0,
            totalPriceExclTax: 0
        };
        state.selectedProducts.forEach(o => {
            prices.priceInclTax += (o.price_incl_tax * o.qty);
            prices.priceExclTax += (o.price_excl_tax * o.qty);
            prices.totalPriceInclTax += (o.final_price_incl_tax * o.qty);
            prices.totalPriceExclTax += (o.final_price_excl_tax * o.qty);
        });
        return prices;
    },
    isSaleable: state => {
        let totalQty = 0;
        state.selectedProducts.forEach(o => {
            totalQty += o.qty;
        });
        return Boolean(totalQty);
    }
};

const CatalogGroupedProduct = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default CatalogGroupedProduct;
